import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PremiumFeatureDialogService {
  
  private isVisibleSubject = new BehaviorSubject<boolean>(false);
  private titleSubject = new BehaviorSubject<string>('');
  private textSubject = new BehaviorSubject<string>('');

  isVisible$ = this.isVisibleSubject.asObservable();
  title$ = this.titleSubject.asObservable();
  text$ = this.textSubject.asObservable();

  constructor() {}

  showDialog(title: string, text: string): void {
    this.titleSubject.next(title);
    this.textSubject.next(text);
    this.isVisibleSubject.next(true);
  }

  closeDialog(): void {
    this.isVisibleSubject.next(false);
  }
}